<epc-advanced-mdo-grid
  class="pre-pack"
  [columns]="shipTos"
  [rows]="prePacks"
  [rowHeadTemplate]="rowHeadTemplate"
  [rowDetailsTemplate]="rowDetailsTemplate"
  [cellTemplate]="cellTemplate"
  [headerName]="displayPrepackModeLabel"
  [portable]="portable"
  [shopTotals]="shopTotals"
  (valuesCopied)="onCopy($event)"
  (clearShop)="clearShop.emit($event)"
>
  <ng-template #rowHeadTemplate let-row="row">
    <epc-pre-pack-header
      class="prepack-header"
      [prepack]="row"
      [opened]="row.opened"
      [numberOfImagesToDisplay]="0"
      [totalItemsInPrepactText]="totalItemsInPrepactText(row)"
      [quantityLeft]="getQuantityLeft(row)"
      [quantityWarningThreshold]="quantityWarningThreshold"
      [lowInvetoryWarningText]="lowInvetoryWarningText(row)"
      [showNoosIcon]="false"
      [thumbnailsVisible]="3"
      [oneLineHeader]="true"
      (click)="onRowClicked(row)"
    >
    </epc-pre-pack-header>
  </ng-template>

  <ng-template #rowDetailsTemplate let-row="row">
    <epc-pre-pack-details
      [prepack]="row"
      [deliveryItems]="getDeliveryItems(row)"
      [selectedScale]="selectedScale"
      [scaleSets]="scaleSets"
      [showAddNote]="false"
      [discountVisible]="true"
      [portableGrid]="true"
      [discount]="getDiscount(row)"
      [titleAttributes]="titleAttributes"
      [collapseState]="collapseState(row.opened)"
      [differentMaterialDimensions]="differentMaterialDimensions"
      [productImageMissingVisualConfig]="productImageMissingVisualConfig"
      (clickedMaterialImage)="selectVariant($event)"
    ></epc-pre-pack-details>
  </ng-template>

  <ng-template
    #cellTemplate
    let-column="column"
    let-row="row"
    let-portable="portable"
    let-rowIndex="rowIndex"
    let-colIndex="colIndex"
  >
    <input
      type="text"
      mdoNavCell
      #input
      class="size-quantity"
      min="0"
      atxMax
      data-e2e="advanced-mdo-cell-input"
      [class.portable]="portable"
      [max]="getMaxQuantity(row, column)"
      [value]="getQuantity(column.id, row.productId)"
      (input)="onQuantityInput(row, column, $event.target.value)"
      (keydown.-)="$event.preventDefault()"
      (focus)="
        selectVariant({ materialId: row.variants[0]?.displayedProductId });
        $event.target.click()
      "
      (click)="input.select()"
      inputmode="numeric"
    />
  </ng-template>
</epc-advanced-mdo-grid>
